import { Component, Inject, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { RouteId } from 'src/app/enums/env/routes-id-enum';
import { MainRoute } from 'src/app/models/MainRoute';
import { StationsRepo } from 'src/app/repositories/stations/repo/station-repo';
import { RoutingService } from 'src/app/services/Routing.service';
import { Station } from 'src/swagger-gen/web-secured/models';

@Component({
    selector: 'app-modal-delete-station',
    templateUrl: './modal-delete-station.component.html',
    styleUrls: ['./modal-delete-station.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModalDeleteStationComponent implements OnDestroy {
  destroyed$ = new Subject<void>();
  loading = false;
  deleteSuccess: any;
  deleteError: any;
  currentRoute: MainRoute;

  constructor(
    @Inject(MAT_DIALOG_DATA) public station: Station,
    private apiService: StationsRepo,
    private translate: TranslateService,
    private router: Router
  ) {
    this.currentRoute = RoutingService.getStationRoute();
  }

  deleteStation() {
    this.loading = true;
    this.apiService
      .deleteStation(this.station.uid)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (res) => {
          this.loading = false;
          this.deleteSuccess = this.translate.instant(
            'stations.delete.success'
          );
        },
        error: (err) => {
          this.loading = false;
          this.deleteError = this.translate.instant(
            'stations.delete.error'
          );
        },
      });
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
